import { render, staticRenderFns } from "./RankingPanel.vue?vue&type=template&id=6f594ab7&scoped=true&"
import script from "./RankingPanel.vue?vue&type=script&lang=ts&"
export * from "./RankingPanel.vue?vue&type=script&lang=ts&"
import style0 from "./RankingPanel.vue?vue&type=style&index=0&id=6f594ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f594ab7",
  null
  
)

export default component.exports